import React from 'react';

const Blog = () => {
    return (
        <div>
            <h1 className='py-5 text-white text-center'>Blog Comming Soon!</h1>
        </div>
    );
};

export default Blog;